import { render } from "./ConfirmationTitle.vue?vue&type=template&id=0c6673a2"
import script from "./ConfirmationTitle.vue?vue&type=script&lang=js"
export * from "./ConfirmationTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__